/**
 * @Author: qinyifang
 * @Date: 2025-04-28 14:34:28
 * @Description: 用户状态管理模块
 */
import { defineStore } from "pinia"
import type { UserState, LoginInfo } from "@/types/app"

export const useUserStore = defineStore("user", {
  state: (): UserState => ({
    loginInfoByPlatform: {}, // 按平台存储的登录信息，key 为平台标识（"ai" 或 "ai_id" 等）
    currentIdByPlatform: {}, // 记录每个平台当前活跃的 ID
    currentPlatform: "ai", // 当前平台标识，默认为 ai
    keepAliveInclude: [], //缓存的组件列表
    keepAliveExclude: [] // 不缓存
  }),
  actions: {
    // 设置当前平台标识
    setCurrentPlatform(platform: string) {
      this.currentPlatform = platform
    },
    // 按平台和 ID 设置登录信息
    setLoginInfoByPlatform(platform: string, info: LoginInfo | null, id?: string) {
      if (id) {
        this.currentIdByPlatform[platform] = id
      }
      const key = id ? `${platform}_${id}` : platform
      if (info) {
        this.loginInfoByPlatform[key] = info
      } else {
        delete this.loginInfoByPlatform[key]
      }
    },
    // 根据平台获取登录信息
    getLoginInfoByPlatform(platform?: string, id?: string): LoginInfo | null {
      const currentPlatform = platform || this.currentPlatform
      const activeId = id || this.currentIdByPlatform[currentPlatform]
      const key = activeId ? `${currentPlatform}_${activeId}` : currentPlatform
      return this.loginInfoByPlatform[key] || null
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: "user",
        storage: localStorage,
        paths: ["loginInfoByPlatform", "currentIdByPlatform", "currentPlatform"]
      }
    ]
  }
})
